export const ACTIVITY_SIDEBAR_WIDTH = {
  DEFAULT: 100,
  MIN: 80,
  MAX: 300,
  MIN_CONTENT: 160,
  KEYBOARD_STEP: 4,
  STEP_PX: 4,
} as const;
